import MyBread from '../../components/Breadcrumbs'
import React, { Fragment, useEffect, useState, Dispatch, SetStateAction } from 'react'
import MaterialTable from 'material-table'
import { ThemeProvider, createTheme, CircularProgress } from '@mui/material';
import { useModal } from 'react-hooks-use-modal';
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from '../../hooks/use-auth';
import axios from 'axios';
import IdSearchButtonWithParent from '../../components/IdSearchButtonWithParent';
import config from 'config';
import { removeKeyWithValue } from 'utils';
import { DeletedContents } from 'styles/styles';
import { Wrapper, PageTitle, CreateNew, ModalStyle, FormLabel, FormInput, FormLabelInputWrapper, ModalTitle, ModalForm, ModalSubmit, LoadingContainer, ModalClose, DivMargin } from 'styles/styles';

interface ParentProps {
  data: ParentDataProps[];
  selectedId: number;
  setSelectedId: Dispatch<SetStateAction<number>>;
  setIsParentDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ChildProps {
  data: ChildDataProps[];
  setIsChildDataInsert: Dispatch<SetStateAction<boolean>>;
  selectedId: number;
}

interface ParentDataProps {
  product_number_id: number
  memo: string
  display_id: string
  [key: string]: string | number;
}

interface ChildDataProps {
  product_number_id: number
  display_id: string
  customer_id: number
  customer_branch: string
  name: string
  name_kana: string
  memo: string
  [key: string]: string | number;
}

const Parent = ({ data, selectedId, setSelectedId, setIsParentDataInsert }: ParentProps) => {
  const auth = useAuth();
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [modalTitle, setModalTitle] = React.useState('');
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  const { reset, register, handleSubmit, watch, formState: { errors } } = useForm<ParentDataProps>();
  const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {
    let alertList: any[] = [];
    const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined || submitData[key] === '') {
        alertList.push(key)
      }
    });
    if (alertList.length) {
      let text = '';
      parentArray.forEach(item => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== '') {
        alert(text);
        throw new Error('必須項目が未入力です');
      }
    }
    submitData = removeKeyWithValue(submitData, '');
    const branchData = {
      memo: submitData.memo,
      display_id: submitData.display_id,
    }
    try {
      setIsSubmitDisable(true);
      if (selectedId === 0) {
        const res = await axios.post(`/v0/factories/${auth.factoryId}/product-numbers`, branchData, {
          headers: auth.authorizationHeader
        });
        window.alert("登録が完了しました");
      } else {
        await axios.patch(`/v0/factories/${auth.factoryId}/product-numbers`, branchData, {
          headers: auth.authorizationHeader,
          params: { id: selectedId }
        });
        window.alert("変更が完了しました");
      }
      close();
      setIsParentDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [{ title: '', field: 'product_number_id' },
  { title: '品番ID', field: 'display_id', default: 'product-number-1', type: 'alphanumeric', required: true },
  { title: 'メモ', field: 'memo', default: 'メモです', type: 'text' }]
  const PAGE_TITLE = "品番"
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title) {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      })
    }
  }
  const listItems = parentArray.map((element: any, index) => {
    if (element.title) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput {...register(element.field)}
              {...(element.type && { type: config.inputErrorMessage[element.type].type })}
              {...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
              {...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
              {...(element.type && { title: config.inputErrorMessage[element.type].title })}
              {...(element.required && { required: true })}
              {...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
              {...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
            />
          </FormLabelInputWrapper>
        </Fragment>
      )
    }
  }
  );
  //カラムなど生成ここまで

  const [pageSize, setPageSize] = React.useState(5);
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);

  //IDから既存の値を呼び出し
  async function setModalValue(product_number_id: number) {
    if (product_number_id === 0) {
      setSelectedId(0);
      reset(defaultObj);
      setModalTitle("新規作成")
    } else {
      //データの取得axios
      setSelectedId(product_number_id);
      try {
        axios.get(`/v0/factories/${auth.factoryId}/product-numbers`, {
          headers: auth.authorizationHeader,
          params: { id: product_number_id }
        }).then((res: any) => {
          reset(res.data[0]);
          setModalTitle("編集")
        });
      } catch (err) {
        console.log(err)
      }
    }
  }

  const createNew = async () => {
    await setModalValue(0);
    open();
  }

  return (
    <>
      <CreateNew onClick={createNew}>新規作成</CreateNew>
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          actions={[
            {
              icon: 'edit',
              tooltip: '編集する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                try {
                  await setModalValue(rowData.product_number_id);
                  open();
                } catch (error) {
                  console.log(error)
                }
              }
            },
            {
              icon: 'delete',
              tooltip: '削除する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                const result = window.confirm(`${rowData.display_id}を削除しますか？`);
                if (result) {
                  try {
                    await axios.delete(`/v0/factories/${auth.factoryId}/product-numbers`, {
                      headers: auth.authorizationHeader,
                      params: { id: rowData.product_number_id }
                    });
                    setSelectedId(0);
                    setIsParentDataInsert(true);
                  } catch (error: any) {
                    window.alert(error.response.data.error);
                  }
                }
              }
            }
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: 'nowrap' },
            rowStyle: (rowData) => ({
              overflowWrap: 'break-word',
              backgroundColor: selectedRow === rowData.tableData.id ? '#EEE' : '#FFF',
            })
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
            setSelectedId(rowData.product_number_id);
            setSelectedRow(rowData.tableData.id);
          }}
        />
      </ThemeProvider>

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  )
}


const Child = ({ data, setIsChildDataInsert, selectedId }: ChildProps) => {
  const auth = useAuth();
  const [selectedBranch, setSelectedBranch] = React.useState(0);
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const [pageSize, setPageSize] = React.useState(5);
  const [modalTitle, setModalTitle] = React.useState('');
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  const { reset, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<ChildDataProps>();
  const onSubmit: SubmitHandler<ChildDataProps> = async (submitData: ChildDataProps) => {
    let alertList: any[] = [];
    const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined || submitData[key] === '') {
        alertList.push(key)
      }
    });
    if (alertList.length) {
      let text = '';
      parentArray.forEach(item => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== '') {
        alert(text);
        throw new Error('必須項目が未入力です');
      }
    }
    submitData = removeKeyWithValue(submitData, '');
    const branchData = {
      display_id: submitData.display_id,
      customer_id: submitData.customer_id,
      customer_branch_id: submitData.customer_branch_id,
      name: submitData.name,
      name_kana: submitData.name_kana,
      memo: submitData.memo,
    };
    try {
      setIsSubmitDisable(true);
      if (!selectedBranch) {
        await axios.post(`/v0/product-numbers/${selectedId}/branches`, branchData, {
          headers: auth.authorizationHeader,
          params: { factory_id: auth.factoryId }
        });
        window.alert("登録が完了しました");
      } else {
        await axios.patch(`/v0/product-numbers/${selectedId}/branches`, branchData, {
          headers: auth.authorizationHeader,
          params: {
            selected_branch: selectedBranch,
            factory_id: auth.factoryId
          }
        });
        window.alert("変更が完了しました");
      }
      close();
      setIsChildDataInsert(true);
    } catch (error: any) {
      window.alert(error.response.data.error);
    }
    setIsSubmitDisable(false);
  };
  //modal end

  //arrayの生成
  const parentArray = [{ title: '', field: 'product_number_id' },
  { title: '', field: 'product_number_branch_id' },
  { title: '枝番', field: 'display_id', default: '00', type: 'branch', required: true },
  { title: '', field: 'customer_id' },
  { title: '', field: 'customer_is_deleted' },
  { title: '得意先ID', field: 'customer_display_id', default: '', required: true, disable: true },
  { title: '得意先名', field: 'customer_name', default: '', required: true, disable: true },
  { title: '', field: 'customer_branch_id' },
  { title: '', field: 'customer_branch_is_deleted' },
  { title: '得意先枝番', field: 'customer_branch_display_id', default: '', required: true, disable: true },
  { title: '得意先担当者名', field: 'customer_branch_name', default: '', search: 'customers', required: true, disable: true },
  { title: '品名', field: 'name', default: '機材', type: 'text', required: true },
  { title: '品名（カナ）', field: 'name_kana', default: 'キザイ', type: 'text' },
  { title: 'メモ', field: 'memo', default: 'メモ', type: 'text' },
  ]
  const PAGE_TITLE = "品番枝番"
  const defaultObj: any = {};
  for (const element of parentArray) {
    defaultObj[element.field] = element.default;
  }
  const columnsArray: any = [];

  function isConditionSatisfied(rowData: any, field: string): boolean {
    return (
      (rowData.customer_is_deleted &&
        (field === 'customer_display_id' ||
          field === 'customer_name' ||
          field === 'customer_branch_display_id' ||
          field === 'customer_branch_name')) ||
      (rowData.customer_branch_is_deleted &&
        (field === 'customer_branch_display_id' || field === 'customer_branch_name'))
    );
  }

  for (const element of parentArray) {
    if (element.title) {
      const title = element.title;
      const field = element.field;
      const tmpObj = {
        title: title,
        field: field,
        render: (rowData: any) => {
          if (isConditionSatisfied(rowData, field)) {
            return (
              <DeletedContents>
                {rowData[field]}
              </DeletedContents>
            );
          } else {
            return rowData[field]
          }
        },
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      };
      columnsArray.push(tmpObj)
    }
  }

  const [selectedCustomerContents, setSelectedCustomerContents] = useState<any>('');
  const [selectedCustomerBranchContents, setSelectedCustomerBranchContents] = useState<any>('');

  useEffect(() => {
    setValue('customer_id', selectedCustomerContents.customer_id);
    setValue('customer_display_id', selectedCustomerContents.display_id);
    setValue('customer_name', selectedCustomerContents.name);
    setValue('customer_branch_id', selectedCustomerBranchContents.customer_branch_id)
    setValue('customer_branch_display_id', selectedCustomerBranchContents.display_id)
    setValue('customer_branch_name', selectedCustomerBranchContents.name)
  }, [selectedCustomerContents, selectedCustomerBranchContents]);

  const listItems = parentArray.map((element: any, index) => {
    if (element.title) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput {...register(element.field)}
              {...(element.type && { type: config.inputErrorMessage[element.type].type })}
              {...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
              {...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
              {...(element.type && { title: config.inputErrorMessage[element.type].title })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
              {...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
            />
            {element.search === "customers" ? <IdSearchButtonWithParent search={element.search} setSelectedContents={setSelectedCustomerContents} setSelectedBranchContents={setSelectedCustomerBranchContents} /> : <></>}
          </FormLabelInputWrapper>
        </Fragment>
      )
    }
  }
  );
  //カラムなど生成ここまで

  const defaultMaterialTheme = createTheme();

  //IDから既存の値を呼び出し
  async function setModalValue(product_number_branch_id: number) {
    if (!product_number_branch_id) {
      setSelectedBranch(0);
      reset(defaultObj);
      setModalTitle("新規作成")
    } else {
      //データの取得axios
      setSelectedBranch(product_number_branch_id);
      const result: any = await axios.get(`/v0/product-numbers/${selectedId}/branches`, {
        headers: auth.authorizationHeader,
        params: {
          selected_branch: product_number_branch_id,
          factory_id: auth.factoryId
        }
      });
      reset(result.data[0]);
      setModalTitle("編集")
    }
  }

  const createNew = async () => {
    await setModalValue(0);
    open();
  }

  return (
    <>
      {selectedId === 0 ? "" : <CreateNew onClick={createNew}>新規作成</CreateNew>}
      <ThemeProvider theme={defaultMaterialTheme}>
        <MaterialTable
          title={PAGE_TITLE}
          columns={columnsArray}
          data={data}
          actions={[
            {
              icon: 'edit',
              tooltip: '編集する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                try {
                  await setModalValue(rowData.product_number_branch_id);
                  open();
                } catch (error) {
                  console.log(error);
                }
              }
            },
            {
              icon: 'delete',
              tooltip: '削除する',
              onClick: async (event, rowData: any) => {
                event.preventDefault();
                const result = window.confirm(`${rowData.display_id}を削除しますか？`);
                if (result) {
                  try {
                    await axios.delete(`/v0/product-numbers/${selectedId}/branches`, {
                      headers: auth.authorizationHeader,
                      params: {
                        selected_branch: rowData.product_number_branch_id,
                        factory_id: auth.factoryId
                      }
                    });
                    setIsChildDataInsert(true);
                  } catch (error: any) {
                    window.alert(error.response.data.error);
                  }
                }
              }
            }
          ]}
          options={{
            actionsColumnIndex: -1,
            headerStyle: { whiteSpace: 'nowrap' },
            rowStyle: { overflowWrap: 'break-word' }
          }}
          onChangeRowsPerPage={(pageSize) => {
            setPageSize(pageSize);
          }}
          onRowClick={(event: any, rowData: any) => {
            event.preventDefault();
          }}
        />
      </ThemeProvider>

      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={close}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  )
}

export default function ProductNumbers() {
  const auth = useAuth();
  const [isParentDataInsert, setIsParentDataInsert] = useState<boolean>(false);
  const [isChildDataInsert, setIsChildDataInsert] = useState<boolean>(false);
  const [parentData, setParentData] = useState<ParentDataProps[]>([]);
  const [childData, setChildData] = useState<ChildDataProps[]>([]);
  const [selectedId, setSelectedId] = useState<number>(0);

  useEffect(() => {
    try {
      axios.get(`/v0/factories/${auth.factoryId}/product-numbers`, {
        headers: auth.authorizationHeader
      }).then((res: any) => {
        if (res.data.length) {
          setParentData(res.data);
        } else {
          setParentData([]);
        }
        setIsParentDataInsert(false)
      })
    } catch (err) {
      console.log(err)
    }
  }, [auth, isParentDataInsert]);

  useEffect(() => {
    if (selectedId === 0) {
      setChildData([]);
    } else {
      try {
        axios.get(`/v0/product-numbers/${selectedId}/branches`, {
          headers: auth.authorizationHeader,
          params: {
            factory_id: auth.factoryId
          }
        }).then((res: any) => {
          if (res.data.length) {
            setChildData(res.data)
          } else {
            setChildData([]);
          }
          setIsChildDataInsert(false)
        });
      } catch (err) {
        console.log(err)
      }
    }
  }, [auth, selectedId, isChildDataInsert])

  return (
    <>
      <Wrapper>
        <MyBread />
        <PageTitle>品番マスタ</PageTitle>
        <Parent data={parentData} selectedId={selectedId} setSelectedId={setSelectedId} setIsParentDataInsert={setIsParentDataInsert} />
        <DivMargin></DivMargin>
        <Child data={childData} selectedId={selectedId} setIsChildDataInsert={setIsChildDataInsert} />
      </Wrapper>
    </>
  )
}